import type { FaireProductEntity } from "../../entity_types/product";

export const p_nryc8h2rjs: FaireProductEntity = {
  token: "p_nryc8h2rjs",
  type: "product",
  name: "18K Gold Plated Waterproof Stainless Steel Hoop Earrings - 7076",
  brandToken: "b_4zc36e4kj9",
  brandName: "Mia Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/649022f117953b8e630e951c9cc3d3b9ed7dbff09a45a25268e307919555c2f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2aa0d92fb42f91ec632c6d9a989cf38e048bd19d251276b9ea7cb141d22a1f72.jpeg",
    "https://cdn.faire.com/fastly/a1ecf678f7aa377c80d3654d9d680454ba9a00bb3a3b0587b53f228e1f84bec0.jpeg",
    "https://cdn.faire.com/fastly/aeb28ee536df6450d5f1f69c1d824a380de86fa3773ca39adf886d3fca74ba9b.jpeg",
    "https://cdn.faire.com/fastly/330cdb209f9ab4b2e7b25276c57fad4c34bdf6d5d1f959239b1870ac9371081c.jpeg",
    "https://cdn.faire.com/fastly/1513ed2276c402758f0a28018cf75356cb64735b328e51f0c13ba3c3bc96e190.jpeg",
    "https://cdn.faire.com/fastly/5de0b5767055760bca421e85fc1aad5cf13d337f79f6c86ef55039d87db2edc7.jpeg",
    "https://cdn.faire.com/fastly/64e38898bf2c090072242de6d18cff417908338f061eab4b85a56c00bca952f0.jpeg",
    "https://cdn.faire.com/fastly/73fc777664c3d6ac5b635e7dc156d9b842cb267ca5c8b9346ba3633901ccfc7f.jpeg",
  ],
  priceDollars: 5.89,
  description:
    '18K Gold Dipped Stainless Steel Knot Hoop Earrings.\nApprox. 0.9"L\n\n\n\nThese earrings are hypoallergenic, waterproof and tarnish-resistant.\n\n*To prolong the shine and finish of the gold plating, contact with chemicals such as lotions, perfumes, and cleaning products should be avoided.*\n\n\n\n\n',
  tags: [],
  msrpDollars: 23.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:24.175Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
